import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <p>Todos los derechos reservados</p>
    </div>
  );
};

export default Footer;
